import api from 'Application/api/api';

const uploadGeneralProjectFiles = (projectId, files, cancelToken = null) => {
    const formData = new FormData();

    files.forEach((file, index) => {
        formData.append(`file${index}`, file);
    });

    return api.post(`project-manager/projects/${projectId}/files`, formData, {
        cancelToken,
        timeout: 30 * 1000,
    });
};

export default uploadGeneralProjectFiles;
